import { initApp } from '~/helpers/app';

// Initialize the app for PWA/web context
initApp('#app', '/', true)
    .then(() => {
        // Hide loading screen and show app
        const loading = document.getElementById('loading');
        const app = document.getElementById('app');

        if (loading && app) {
            loading.style.display = 'none';
            app.style.display = 'block';
        }
    })
    .catch((error) => {
        console.error('Failed to initialize app:', error);
        // Show error message to user
        const loading = document.getElementById('loading');
        if (loading) {
            loading.innerHTML = `
            <div style="text-align: center; color: white;">
                <h2>Failed to load application</h2>
                <p>Please refresh the page and try again.</p>
            </div>
        `;
        }
    });
